import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { SEARCH_SPACELIFT_VCS_REPO_COMMITS_SUGGESTIONS } from "./gql";

type UseSearchSpaceliftVcsRepoCommitsSuggestionsProps = {
  repoId: string | undefined;
};

const useSearchSpaceliftVcsRepoCommitsSuggestions = ({
  repoId,
}: UseSearchSpaceliftVcsRepoCommitsSuggestionsProps) => {
  const { data, error, loading, previousData } = useQuery(
    SEARCH_SPACELIFT_VCS_REPO_COMMITS_SUGGESTIONS,
    {
      variables: {
        repoID: repoId || "",
        input: {
          fullTextSearch: null,
          predicates: null,
          fields: null,
        },
      },
      skip: !repoId,
    }
  );

  const cachedSuggestions = useMemo(() => {
    return (
      data?.searchRepoCommitsSuggestions?.fields ||
      previousData?.searchRepoCommitsSuggestions?.fields ||
      []
    );
  }, [data, previousData]);

  const filteredCount = useMemo(() => {
    return (
      data?.searchRepoCommitsSuggestions?.filteredCount ||
      previousData?.searchRepoCommitsSuggestions?.filteredCount ||
      0
    );
  }, [data, previousData]);

  return {
    cachedSuggestions,
    filteredCount,
    loading,
    error,
  };
};

export default useSearchSpaceliftVcsRepoCommitsSuggestions;
